import request from '@/utils/request'

/**
 * 获取菜单组列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回菜单组列表
 */
export function listMenuGroups(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroup.listMenuGroups',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存菜单组
 * @param {Object} data 菜单组数据
 * @returns {Promise} 返回保存结果
 */
export function saveMenuGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroup.saveMenuGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新菜单组
 * @param {Object} data 菜单组数据
 * @returns {Promise} 返回更新结果
 */
export function updateMenuGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroup.updateMenuGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除菜单组
 * @param {Object} data 菜单组数据
 * @returns {Promise} 返回删除结果
 */
export function deleteMenuGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroup.deleteMenuGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}